import React from 'react';
import {SwipeableDrawer} from "@mui/material";
import uiStore from "../../lib/stores/uiStore";
import {observer} from "mobx-react";
import {ReactionPanel} from "./ReactionPanel";

const MobileReactionPanel = () => {

    return <SwipeableDrawer
            anchor={"bottom"}
            open={!!uiStore.reactionPanelMessage}
            onOpen={() => {

            }}
            onClose={() => uiStore.reactionPanelMessage = null}
            PaperProps={{
                sx: {
                    maxHeight: "200px",
                    width: "100%",
                },
            }}
    >
        <ReactionPanel message={uiStore.reactionPanelMessage} onClose={() => {
            uiStore.reactionPanelMessage = null;
        }}/>
    </SwipeableDrawer>
};

export default observer(MobileReactionPanel);
